import * as React from 'react';
import { AdminDashboardPageLayout } from '../../containers/AdminDashboardPageLayout';
import { AutomationTemplates } from '../../containers/templates/AutomationTemplates';

export const AdminAutomationsPage: React.FC = () => {
	return (
		<AdminDashboardPageLayout>
			<AutomationTemplates />
		</AdminDashboardPageLayout>
	);
};
